<template>
  <div>
    <v-text-field readonly :prepend-icon="icon" single-line v-model="filename" :label="label" :required="required" @click.native="onFocus" :disabled="disabled" ref="fileTextField"></v-text-field>
    <input type="file" :accept="accept" :multiple="multiple" :disabled="disabled" ref="fileInput" @change="onFileChange">
    <bottom-sheet v-model="sheet">
      <v-list>
        <v-subheader>Escolher uma ação</v-subheader>
        <v-list-tile @click="androidCamera">
          <v-list-tile-action>
            <v-icon>photo_camera</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Câmera</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile @click="androidLibrary">
          <v-list-tile-action>
            <v-icon>photo_library</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Biblioteca de Fotos</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </bottom-sheet>
  </div>
</template>

<script>
  import Vue from 'vue'
  import BottomSheet from './BottomSheet'
  const FormData = require('formdata-polyfill')
  
  export default {
    props: {
      value: {
        type: [Array, String]
      },
      accept: {
        type: String,
        default: '*'
      },
      label: {
        type: String,
        default: 'choose_file'
      },
      icon: {
        type: String,
        default: 'attach_file'
      },
      required: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      multiple: {
        type: Boolean,
        default: false
      }
    },
    components: {
      BottomSheet
    },
    data () {
      return {
        filename: '',
        sheet: false
      }
    },
    watch: {
      value (v) {
        this.filename = v
      }
    },
    mounted () {
      this.filename = this.value
    },

    methods: {
      getFormData (file) {
        const form = new FormData()
        form.append('data', file, file.name)
        return form
      },
      onFocus () {
        if (!this.disabled) {
          if (this.accept === 'image/*' && Vue.cordova && Vue.cordova.device && Vue.cordova.device.platform && Vue.cordova.device.platform === 'Android') {
            setTimeout(() => {
              this.sheet = true
            }, 100)
          } else {
            this.$refs.fileInput.click()
          }
        }
      },
      onFileChange ($event) {
        // const files = $event.target.files || $event.dataTransfer.files
        // const form = this.getFormData(files[0])
        // if (files) {
        //   if (files.length > 0) {
        //     this.filename = [...files].map(file => file.name).join(', ')
        //   } else {
        //     this.filename = null
        //   }
        // } else {
        //   this.filename = $event.target.value.split('\\').pop()
        // }
        const file = $event.target.files[0]
        this.filename = file.name
        this.$emit('input', this.filename)
        this.$emit('formData', file)
      },
      processAndroidPicture (imageData) {
        this.$store.dispatch('utils/showLoading')
        window.resolveLocalFileSystemURL(imageData, (fileEntry) => {
          fileEntry.file((file) => {
            this.filename = file.name

            this.$emit('input', this.filename)
            this.$emit('formData', file)

            this.$store.dispatch('utils/hideLoading')
          })
        })
      },
      androidCamera () {
        this.sheet = false
        Vue.cordova.camera.getPicture((imageData) => {
          this.processAndroidPicture(imageData)
        }, () => {
          console.log('Erro')
        }, {
          quality: 80,
          sourceType: Vue.cordova.camera.PictureSourceType.CAMERA,
          destinationType: Vue.cordova.camera.DestinationType.FILE_URI,
          correctOrientation: true,
          saveToPhotoAlbum: true
        })
      },
      androidLibrary () {
        this.sheet = false
        Vue.cordova.camera.getPicture((imageData) => {
          this.processAndroidPicture(imageData)
        }, () => {
          console.log('Erro')
        }, {
          quality: 80,
          sourceType: Vue.cordova.camera.PictureSourceType.PHOTOLIBRARY,
          destinationType: Vue.cordova.camera.DestinationType.FILE_URI,
          correctOrientation: true,
          saveToPhotoAlbum: true
        })
      }
    }
  }
</script>

<style scoped>
  input[type=file] {
    position: absolute;
    left: -99999px;
  }
  .dialog__container { display: none !important; }
  .list__tile__action { min-width: 38px !important; }
  .subheader { background: none !important; text-align: left !important; }
</style>



// WEBPACK FOOTER //
// FileInput.vue?73973b5a